"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _IndividualTable = _interopRequireDefault(require("./CampaignCreator/FindPersonas/IndividualTable"));

var _CharacteristicsFilterTagList = _interopRequireDefault(require("./CampaignCreator/CharacteristicsFilterTagList"));

var _CampaignPersonaFilterTagList = _interopRequireDefault(require("../containers/CampaignCreator/CampaignPersonaFilterTagList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IndividualTab = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(IndividualTab, _React$Component);

  function IndividualTab() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      cndIsDown: false,
      cndStartX: 0,
      cndScrollLeft: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (e) {
      _this.setState({
        cndIsDown: true
      });

      e.currentTarget.classList.add('active');

      _this.setState({
        cndStartX: e.pageX - e.currentTarget.offsetLeft
      });

      _this.setState({
        cndScrollLeft: e.currentTarget.scrollLeft
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseExit", function (e) {
      _this.setState({
        cndIsDown: false
      });

      e.currentTarget.classList.remove('active');
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (e) {
      if (!_this.state.cndIsDown) return;
      e.preventDefault();
      var x = e.pageX - e.currentTarget.offsetLeft;
      var walk = (x - _this.state.cndStartX) * 3; //scroll-fast

      e.currentTarget.scrollLeft = _this.state.cndScrollLeft - walk;
    });

    return _this;
  }

  var _proto = IndividualTab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        selectedCharacteristics = _this$props.selectedCharacteristics,
        loadIndividual = _this$props.loadIndividual,
        tagId = _this$props.tagId;

    if (selectedCharacteristics) {
      loadIndividual(tagId);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        tagId = _this$props2.tagId,
        selectedCharacteristics = _this$props2.selectedCharacteristics,
        loadIndividual = _this$props2.loadIndividual;
    var prevSelectedCharacteristics = prevProps.selectedCharacteristics;
    var selectedCharacteristicsLength = selectedCharacteristics.characteristics ? selectedCharacteristics.characteristics.length : 0;
    var prevSelectedCharacteristicsLength = prevSelectedCharacteristics.characteristics ? prevSelectedCharacteristics.characteristics.length : 0;

    if (selectedCharacteristicsLength > prevSelectedCharacteristicsLength) {
      loadIndividual(tagId);
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        hideUnselectedPersonas = _this$props3.hideUnselectedPersonas,
        handleSelectPersona = _this$props3.handleSelectPersona,
        communityColours = _this$props3.communityColours,
        handleHideUnselectedPersonas = _this$props3.handleHideUnselectedPersonas,
        individualPersonaRecords = _this$props3.individualPersonaRecords,
        isFetching = _this$props3.isFetching,
        selectedPersonas = _this$props3.selectedPersonas,
        selectedMeasure = _this$props3.selectedMeasure,
        selectedCharacteristics = _this$props3.selectedCharacteristics,
        unformattedPersonas = _this$props3.unformattedPersonas,
        filters = _this$props3.filters,
        theme = _this$props3.theme,
        isDataPage = _this$props3.isDataPage,
        audienceView = _this$props3.audienceView,
        removeSelectedCharacteristic = _this$props3.removeSelectedCharacteristic;
    return /*#__PURE__*/React.createElement(_semanticUiReact.Tab.Pane, {
      className: "collapsing " + (isDataPage ? 'individual-table--data-explorer' : '')
    }, !isDataPage && /*#__PURE__*/React.createElement(_CharacteristicsFilterTagList["default"], null), !isDataPage && /*#__PURE__*/React.createElement(_CampaignPersonaFilterTagList["default"], {
      filters: filters,
      theme: theme
    }), /*#__PURE__*/React.createElement("div", {
      className: "table-container-overflow",
      onMouseDown: this.handleMouseDown,
      onMouseLeave: this.handleMouseExit,
      onMouseUp: this.handleMouseExit,
      onMouseMove: this.handleMouseMove
    }, /*#__PURE__*/React.createElement(_IndividualTable["default"], {
      audienceView: audienceView,
      hideUnselectedPersonas: hideUnselectedPersonas,
      handleHideUnselectedPersonas: handleHideUnselectedPersonas,
      individualPersonaRecords: individualPersonaRecords,
      communityColours: communityColours,
      handleSelectPersona: handleSelectPersona,
      selectedCharacteristics: selectedCharacteristics,
      selectedPersonas: selectedPersonas,
      selectedMeasure: selectedMeasure,
      unformattedPersonas: unformattedPersonas,
      isFetching: isFetching,
      removeSelectedCharacteristic: removeSelectedCharacteristic,
      isDataPage: isDataPage
    })));
  };

  return IndividualTab;
}(React.Component);

exports["default"] = IndividualTab;